import { Component } from '@angular/core';
import { DatePipe } from "@angular/common";
import { RouterOutlet } from '@angular/router';
import { NgFor } from "@angular/common";
import { NgClass } from "@angular/common";
import { Observable, of } from 'rxjs';


import { PlayList } from '../../objects/playlist';
import { PlayListFilter } from '../../objects/playlistfilter';

import { MatTableModule } from '@angular/material/table';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';

import { MatIconModule } from '@angular/material/icon';
import { DataSource } from '@angular/cdk/collections';
import { PlayListDataService } from '../../services/playlist-data-service';


import { NgIf } from "@angular/common";


import { MatListModule } from '@angular/material/list';
import {
  MAT_DIALOG_DATA,
  MatDialogTitle,
  MatDialogContent,
} from '@angular/material/dialog';




import { MatTableDataSource } from '@angular/material/table';

import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

import { CommonModule } from '@angular/common';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';

import { MatDatepickerModule } from '@angular/material/datepicker';
import { provideNativeDateAdapter } from '@angular/material/core';
import { provideMomentDateAdapter } from '@angular/material-moment-adapter';
import { MY_FORMATS } from '../mydateformat';
import { PlayListItem } from '../../objects/playlistitem';

import { MatSelectModule } from '@angular/material/select';








/**
 * @title Basic use of the tab group
 */
@Component({
  selector: 'playlist-component',
  templateUrl: './playlist-component.html',
  styleUrls: ['./playlist-component.css'],
  standalone: true,
  imports: [NgFor, NgIf, NgClass, CommonModule, MatDialogModule, MatDatepickerModule, MatButtonModule, MatDialogTitle, MatDialogContent, MatFormFieldModule, MatInputModule, MatButtonModule, MatIconModule, MatSelectModule, FormsModule, MatTableModule, DatePipe, MatDatepickerModule],
  providers: [provideMomentDateAdapter(MY_FORMATS)]
})
export class PlayListComponent {

  playlistfilter: PlayListFilter = {
    startlistdate: null, 
    filterdate: "",
    filterhour: ""// or initialize with any default value
    // other properties initialization if needed
  };

  dataSource: MatTableDataSource<PlayListItem>;
  displayedColumns: string[] = ['Image', 'Play', 'Preview', 'Song'];

  playlist: PlayList;  // URL to web api

  private _filterHour: string = "";
  private _filterDate: string = "";


  constructor(private playlistDataService: PlayListDataService) { }

  ngOnInit(): void {
    // Subscribe to the observable returned by getSchedule()
    //this.playlistDataService.getPlayList(this.schedulefilter).subscribe((playlist: PlayList) => {
    //  this.playlist = playlist; // Assign the value to this.schedule when it emits
    //  this.dataSource = playlist.playlistitems;
    //});


    this.playlistfilter.startlistdate = new Date();
    this.playlistfilter.startlistdate.setMinutes(0);
    this.playlistfilter.startlistdate.setSeconds(0);
    this.playlistfilter.filterdate = "";
    this.playlistfilter.filterhour = "";
    

    this.watchPlaylistFilterChanges();



    this.playlistDataService.getPlayList(this.playlistfilter).subscribe((playlist: PlayList) => {

      this.refreshPlaylist(playlist);
      this.watchPlaylistFilterChanges();


    });


  }

  private watchPlaylistFilterChanges() {
    // Use Object.defineProperty to define getters and setters for the properties
    Object.defineProperty(this.playlistfilter, 'filterhour', {
      get: () => this._filterHour,
      set: (value) => {
        if (value !== this._filterHour) {
          this._filterHour = value;
          this.onDateChanged();
        }
      }
    });
    Object.defineProperty(this.playlistfilter, 'filterdate', {
      get: () => this._filterDate,
      set: (value) => {
        if (value !== this._filterDate) {
          this._filterDate = value;
          this.onDateChanged();
        }
      }
    });
  }


  onDateChanged() {
    // Your logic here
    console.log("Selected date:", this.playlistfilter.filterdate);
    console.log("Selected hour:", this.playlistfilter.filterhour);

   // if (this.playlistfilter.filterdate && this.playlistfilter.filterdate.trim() !== '' &&
   //   this.playlistfilter.filterhour && this.playlistfilter.filterhour.trim() !== '') {
    if (this.playlistfilter.filterdate  &&
        this.playlistfilter.filterhour && this.playlistfilter.filterhour.trim() !== '') {
        // Both filterdate and filterhour have valid values
      // Call your method here

      
      var d = new Date(this.playlistfilter.filterdate); // The 0 there is the key, which sets the date to the epoch
      console.log("getdate: ", d);
      
      d.setHours(parseInt(this.playlistfilter.filterhour.substring(0,2)));
      this.playlistfilter.startlistdate = d;

      this.playlistDataService.getPlayList(this.playlistfilter).subscribe((playlist: PlayList) => {

        this.refreshPlaylist(playlist);

      });
    }





    // You can call other methods or perform any actions you need.
  }


  refreshPlaylist(data) {

    this.playlist = data;
    var convts = new Date(parseInt(this.playlist.playlistheader[0].startClockn) * 1000);
    this.playlist.playlistheader[0].startClocknl = convts.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    convts = new Date(this.playlist.playlistheader[0].endClockn * 1000);
    this.playlist.playlistheader[0].endClocknl = convts.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

    this.dataSource = new MatTableDataSource(data.playlistitems);

  }


}
